import React, { useMemo } from 'react';
import { Color, ColorRepresentation, CylinderGeometry, MathUtils, ShaderMaterial } from 'three';
import { Jute } from '../../..';
import { ThreeElements } from '@react-three/fiber';

type IParentProps = ThreeElements['mesh'] & {
  selectActive?: boolean;
  highLight?: boolean;
  transformActive?: boolean;
};

const Beam: React.FunctionComponent<IParentProps> = ({ selectActive = false, transformActive = false, highLight = false, ...meshProps }) => {
  const LENGTH = 0.6;
  const OFFSET = Jute.isPico ? 0.055 : 0.02;

  const geometry = useMemo(() => {
        const geom = new CylinderGeometry(0.003, 0.0028, LENGTH, 16, 2, true);
        geom.computeBoundingBox();
        geom.rotateX(MathUtils.degToRad(90));
        geom.translate(0, 0, -LENGTH/2 + OFFSET);
        return geom;
    }, [])

    let color2Representation: ColorRepresentation = selectActive ? "rgb(5, 213, 250)" : "rgb(214, 255, 254)"
    if (transformActive) color2Representation = "rgb(250, 246, 192)"

    const material = useMemo(() => {
        return new ShaderMaterial({
            transparent: true,
            uniforms: {
              color1: {
                value: new Color('white')
              },
              color2: {
                value: new Color(color2Representation)
                
              },
              bboxMin: {
                value: geometry.boundingBox!.min
              },
              bboxMax: {
                value: geometry.boundingBox!.max
              },

            },
            vertexShader: `
              uniform vec3 bboxMin;
              uniform vec3 bboxMax;

              varying float gradient; 
          
              void main() {
                gradient = (position.z - bboxMin.z) / (bboxMax.z - bboxMin.z);
                gl_Position = projectionMatrix * modelViewMatrix * vec4(position,1.0);
              }
            `,
            fragmentShader: `
              uniform vec3 color1;
              uniform vec3 color2;

              varying float gradient;
              
              void main() {
                float alpha = mix(0.0, 1.0, gradient * 2.0);
                gl_FragColor = vec4(mix(color1, color2, gradient), alpha);
              }
            `,
        })
    }, [selectActive, highLight, transformActive])
    
    return <mesh geometry={geometry} material={material} {...meshProps}/>;
        
}

export default Beam;